export interface WarehouseAdminProductFilters {
    active?: boolean|null;
    categoryId?: number|null;
    retour?: boolean|null;
    inventoryCheck?: boolean|null;
}

export default class WarehouseAdminProductsRequest {
    constructor(
        private readonly filters: WarehouseAdminProductFilters = {}
    ) {}

    toJson(): {
        active?: number;
        category_id?: number;
        retour?: number;
        inventory_check?: number;
    } {
        const data: {
            active?: number;
            category_id?: number;
            retour?: number;
            inventory_check?: number;
        } = {};

        if (this.filters.active !== null && this.filters.active !== undefined) {
            data.active = this.filters.active ? 1 : 0;
        }

        if (this.filters.categoryId !== null && this.filters.categoryId !== undefined) {
            data.category_id = this.filters.categoryId;
        }

        if (this.filters.retour !== null && this.filters.retour !== undefined) {
            data.retour = this.filters.retour ? 1 : 0;
        }

        if (this.filters.inventoryCheck !== null && this.filters.inventoryCheck !== undefined) {
            data.inventory_check = this.filters.inventoryCheck ? 1 : 0;
        }

        return data;
    }
}